module.exports = __webpack_public_path__ + "static/media/male.7e78e8f9.png";